if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      constructor() {
        super();
        this.toggles = Array.from(this.querySelectorAll('[data-tab-toggle]'));
        this.contents = Array.from(this.querySelectorAll('[data-tab]'));

        if(!this.toggles.length || !this.contents.length) return;

        document.querySelectorAll(`[data-tab-toggle="${this.toggles[0].getAttribute('data-tab-toggle')}"]`).forEach((item) => {
          item.classList.add('active');
        });
        this.contents[0].classList.add('active');
        
        this.toggles.forEach((item, index) => {
          item.addEventListener('click', this.toggleTab.bind(this));
        });

        this.classList.add('loaded');
      }

      toggleTab(event) {
        event.preventDefault();
        const toggle = event.target;
        const tabName = toggle.getAttribute('data-tab-toggle');

        if(toggle.classList.contains('active') && toggle.classList.contains('product-tabs__accordion')){
          toggle.classList.remove('active');
          this.contents.find((item) => item.getAttribute('data-tab') === tabName).classList.remove('active');
          return;
        }

        this.toggles.forEach((item) => {
          const itemTabName = item.getAttribute('data-tab-toggle');
          if (item.classList.contains('active')) item.classList.remove('active');
          if(itemTabName === tabName) item.classList.add('active');
        });
        
        this.contents.forEach((item) => {
          const itemTabName = item.getAttribute('data-tab');
          if (item.classList.contains('active')) item.classList.remove('active');
          if(itemTabName === tabName) item.classList.add('active');
        });
      }
    }
  );
}